module.exports = __webpack_public_path__ + "static/media/indian.bff14ec3.png";